// extracted by mini-css-extract-plugin
export default {"projects_full_container":"Projects_projects_full_container__dGSJF","container":"Projects_container__GMrX4","content":"Projects_content__CuuFS","projects":"Projects_projects__5KEr0"};